define('Ames.RentFromAnywhere.RentalConfirmation.Module', [
  'rental_confirmation.tpl',
  "Ames.RentFromAnywhere.RentFromAnywhere.SS2Model",
  "Backbone",
  "Profile.Model",
  "Utils",
], function (
  rentalConfirmationTpl,
  RentFromAnywhereSS2Model,
  Backbone,
  ProfileModel
  ,Utils
  
) {
  'use strict';

  // NetScore rental Sales Order form (PROD 229; sandbox used 215)
  var RENTAL_FORM_ID = 229;

  return Backbone.View.extend({
    template: rentalConfirmationTpl,
    
    initialize: function (options) {
      this.model = new RentFromAnywhereSS2Model();
      var self = this;
      this.normalOrder = null;
      this.rentalOrder = null;
      this.profileModel = ProfileModel.getInstance();
      this.summary = {};
      // Render a spinner immediately; re-render once the orders are loaded
      this.isLoading = true;
      // The checkout wrapper stores the id of the order just placed; ask the
      // service for that order explicitly so we never show the previous one.
      var placedOrderId = null;
      try { placedOrderId = sessionStorage.getItem("rfa_last_order_id"); } catch (e) {}

      var attempts = 0;
      var load = function () {
        attempts++;
        // cache: false + a unique param: the browser must never reuse the
        // previous confirmation's GET response (that is what showed the old order)
        var fetchOptions = { cache: false, data: { _rfa: Date.now() + "-" + attempts } };
        if (placedOrderId) fetchOptions.data.confirmationOrderId = placedOrderId;
        self.model.fetch(fetchOptions).done(function (data) {
          if (!data || data.success === false) {
            self.isLoading = false;
            self.render();
            return;
          }
          // Stale answer (the web order we just placed is not in it yet)?
          // Retry a couple of times before showing whatever came back.
          var ids = [];
          if (data.normalOrder) ids.push(String(data.normalOrder.id));
          if (data.rentalOrder && data.rentalOrder.webOrderId) ids.push(String(data.rentalOrder.webOrderId));
          var matches = !placedOrderId || ids.indexOf(String(placedOrderId)) !== -1;
          if (!matches && attempts < 4) {
            setTimeout(load, 1500);
            return;
          }
          // Right order, but the service found the rental SO before the user
          // event finished building it (settled === false): its tax / totals
          // may still be 0. Wait and ask again before rendering.
          if (data.settled === false && attempts < 6) {
            setTimeout(load, 2000);
            return;
          }

          self.isLoading = false;
          self.summary = data.summary || (data.rentalOrder && data.rentalOrder.summary) || {};
          self.normalOrder = data.normalOrder;
          if (self.normalOrder) {
            self.normalOrder.pdfUrl = window.location.origin + '/scs/download.ssp?asset=order-details&id=' + self.normalOrder.id + '&n=7';
          }
          self.rentalOrder = data.rentalOrder;
          if (self.rentalOrder) {
            self.rentalOrder.pdfUrl = window.location.origin + '/app/accounting/print/hotprint.nl?regular=T&sethotprinter=T&formnumber=' + RENTAL_FORM_ID + '&trantype=salesord&&id=' + self.rentalOrder.id + '&label=Sales+Order&printtype=transaction';
          }
          self.render();
        }).fail(function () {
          self.isLoading = false;
          self.render();
        });
      };
      load();
    },
    getContext: function () {
      var primaryOrder = this.normalOrder || this.rentalOrder;

      return {
        isLoading: !!this.isLoading,
        normalOrder: this.normalOrder,
        rentalOrder: this.rentalOrder,
        // Backwards-compatible fields (old template)
        confirmationNumber: primaryOrder ? primaryOrder.tranid : null,
        orderId: primaryOrder ? primaryOrder.id : null,
        continueURL: Utils.getAbsoluteUrl(''),
        touchPoint: true,
        isNotGuest: this.profileModel.get("isGuest") === 'F',
        onlyRentalOrder: !this.normalOrder && this.rentalOrder,
        summary: this.summary
      };
    },
  });
});
